import { useEffect, useRef, useState } from 'react';

interface UseInfiniteScrollOptions {
    hasMore: boolean;
    loadMore: () => void;
    threshold?: number;
}

export const useInfiniteScroll = ({ hasMore, loadMore, threshold = 200 }: UseInfiniteScrollOptions) => {
    const [isLoading, setIsLoading] = useState(false);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const loadMoreRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!hasMore) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (entry.isIntersecting && !isLoading) {
                    setIsLoading(true);
                    loadMore();
                    // Reset loading dopo un breve delay
                    setTimeout(() => setIsLoading(false), 300);
                }
            },
            {
                rootMargin: `${threshold}px`,
            }
        );

        if (loadMoreRef.current) {
            observer.observe(loadMoreRef.current);
        }

        observerRef.current = observer;

        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        };
    }, [hasMore, loadMore, threshold, isLoading]);

    return { loadMoreRef, isLoading };
};

